type Tprops = { args: any; pass: { fbConfig: any; arrFuncs: any[] } };

export const fireInit = async (props: Tprops) => {
  // // ---------- set Props
  // const { args, pass } = props;
  // const { fbConfig, arrFuncs } = pass;
  // // console.log({ fbConfig, arrFuncs });
  // // console.log({ args });
  // // ---------- set Caps Inputs
  // // const fbConfig = !#!FB Variable Path!#!;
  // // const arrFuncs = [!#!Variable Path To Save!#!];
  // // ---------- set Local Imports
  // const FB_APP = await import('@firebase/app');
  // // console.log({FB_APP});
  // if (typeof fbConfig === 'object') {
  //   // ---------- set FB Init on a Variable
  //   const fbInit = FB_APP.initializeApp(fbConfig, 'secondary');
  //   // console.log({fbInit});
  //   for (const currFunc of arrFuncs) {
  //     await currFunc(fbInit, args);
  //   }
  // } else {
  //   console.log('fbConfig precisa ser um objeto', { fbConfig });
  // }
};
